import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom';

import { makeStyles } from '@material-ui/core';

import Container from '@material-ui/core/Container'
import Button from '@material-ui/core/Button'

import { BackNavAdmin, Search } from '../../components';
import { ExternalContentsTable } from '../../components/Tables'
import { ExternalContentFilter } from '../../components/ExternalContent';

import AddIcon from '@material-ui/icons/Add';

import { DialogDelete } from '../../components/Dialogs'

import { externalContentActions } from '../../actions';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(4),
  },
  filter: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    margin: theme.spacing(3, 0),
  },
  btnNewItem: {
    float: 'right',
    padding: theme.spacing(1, 2),
  },
}));

function ExternalContentsPage(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [externalContent, setExternalContent] = useState({});
  const [showDialog, setShowDialog] = useState(false);

  const {
    externalContents,
    paging,
    paging: { statusCode },
  } = useSelector((state) => state.externalContent);

  const getList = () => {
    dispatch(
      externalContentActions.getExternalContentList(
        1,
        paging.search,
        paging.limit,
        paging.statusCode
      )
    );
  }

  // Run list getter on component mount
  useEffect(() => {
    getList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  // Run list getter action after filter change
  useEffect(() => {
    getList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusCode]);

  const searchExternalContent = () => {}

  const deleteContent = () => {
    dispatch(externalContentActions.deleteContent(externalContent._id))

    setExternalContent({});
    setShowDialog(false);
  }

  const closeDialog = () => {
    setExternalContent({});
    setShowDialog(false);
  }

  return (
    <>
      <BackNavAdmin title={t('conteudos')} pathname="/">
        <Button
          className={classes.btnNewItem}
          variant="contained"
          color="primary"
          type="submit"
          startIcon={<AddIcon />}
          component={Link}
          to="/external-content/new"
        >
          {t('adicionar_novo_conteudo')} 
        </Button>
      </BackNavAdmin>

      <Container maxWidth="lg" className={classes.root}>
        <DialogDelete
          open={showDialog}
          onClose={closeDialog}
          title="deletar conteúdo"
          onAccept={deleteContent}
        />

        <div className={classes.filter}>
          <ExternalContentFilter statusCode={statusCode} />

          <Search
            placeholder={t('pesquise_pelo_nome_do_conteudo')}
            query={searchExternalContent}
          />
        </div>

        <ExternalContentsTable
          externalContent={externalContent}
          setExternalContent={setExternalContent}
          externalContents={externalContents}
          paging={paging}
          history={props.history}
          dialog={{ setOpenDialog: setShowDialog, openDialog: showDialog }}
        />
      </Container>
    </>
      
  );
}

export { ExternalContentsPage };
